import React from "react";
// @ts-ignore - SVG import
import Verified from "../../../assets/icons/verified.svg";
import CardWithShadow from "../../common/CardWithShadow";
import HtmlElement from "../../common/HtmlElement";
import { AppContext } from "../../core/ApplicationContextProvider";
import Contact from "../../template-parts/Contact";
import "./Success.css";
import type { AppContextType } from "../../core/types";

const Success: React.FC = () => {
  const context = React.useContext(AppContext) as AppContextType;
  const { bgHook, details } = context;

  if (!details) {
    return <></>;
  }

  const { businessLineDetails, campaignDetails } = details;
  bgHook.setFixedPage();

  const defaultTitle = "Datele tale sunt în curs de actualizare!";
  const hasCustomSubtitle = !!(
    campaignDetails?.successPage && campaignDetails.successPage.subtitle
  );

  const DefaultSubtitle: React.FC = () => (
    <>
      Îți mulțumim că ai ales să rămâi în contact cu noi. Datele tale personale
      vor fi actualizate de către colegii noștri. Între timp, dacă vrei să ne
      spui ceva ne poți suna la{" "}
      <a
        href={`tel:${businessLineDetails?.phoneNumber}`}
        className="tel-link"
      >
        {businessLineDetails?.phoneNumber}
      </a>{" "}
      sau ne poți trimite oricând un e-mail la{" "}
      <a
        href={`mailto:${businessLineDetails?.email}`}
        className="link"
      >
        {businessLineDetails?.email}
      </a>
      .
    </>
  );

  const Subtitle = hasCustomSubtitle ? (
    <HtmlElement elements={campaignDetails?.successPage?.subtitle}></HtmlElement>
  ) : (
    <DefaultSubtitle />
  );

  return (
    <React.Fragment>
      <div className="container pt-3 pl-0 pr-0 home-element">
        <div className="row mt-5 mb-2 m-right-sm">
          <div className="offset-md-6 col-md-6 mt-5 pr-0 pt-1">
            <CardWithShadow>
              <div className="text-center p-4">
                <img
                  src={Verified}
                  alt="error"
                  className="d-inline-block align-top"
                />
                <h3 className="text-orange pt-2">
                  {(campaignDetails?.successPage &&
                    campaignDetails.successPage.title) ||
                    defaultTitle}
                </h3>
                <div>{Subtitle}</div>
                <p>Îți mulțumim, Echipa NN</p>
              </div>
            </CardWithShadow>
          </div>
        </div>
      </div>
      <div className="container m-bottom-sm pl-md-0 pr-md-0">
        <div className="row m-bottom-sm">
          <Contact
            businessLineDetails={businessLineDetails}
            campaignDetails={campaignDetails}
          />
        </div>
        <div className="row mb-5 d-none d-md-block">
          <div className="col-12 mb-5">
            <br />
            <br />
            <br />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Success;
